import { Setting, SettingType } from '@appblocks/codegeneration/types';
import Tibbit40Node from '@appblocks/codegeneration/Nodes/Tibbit40Node';

export default class Tibbit40_3Node extends Tibbit40Node {
    constructor() {
        super();
        this.name = 'Tibbit 40_3';
        this.id = 'node_tibbit_40_3';
        this.linkedFeature = 'tibbit_40_3';
        this.description = 'Digital potentiometer, 50KOhm';
        this.range = 50000;
        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_40_3',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
